import React from 'react';

/** The parent row of a booking group: the booking, its details and a job count.
 * 8986 / 8989 / 8990 / 8992: job rows are listed beneath their booking; see
 * utils/bookingGroups.js for the grouping.
 */
export default function BookingGroupRow({ group, colSpan, collapsed, onToggle, count, children }) {
  const n = count ?? group.rows.length;
  return (
    <tr className="table-light booking-group" data-testid="booking-group" data-ref={group.ref}>
      <td colSpan={colSpan} className="py-2">
        <div className="d-flex flex-wrap align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm btn-link text-reset p-0 text-decoration-none fw-bold"
            onClick={() => onToggle(group.key)}
            aria-expanded={!collapsed}
            data-testid="booking-group-toggle"
          >
            <i className={`fas fa-chevron-${collapsed ? 'right' : 'down'} me-2 small`} aria-hidden="true" />
            {group.ref}
          </button>
          <span className="small text-muted">{children}</span>
          <span className="badge bg-secondary-subtle text-secondary-emphasis border ms-auto" data-testid="booking-group-count">
            {n} job{n === 1 ? '' : 's'}
          </span>
        </div>
      </td>
    </tr>
  );
}
